import { connect } from 'react-redux'
import _ from 'lodash'
import {
  addToCart,
} from '../actions'

import EventsListComponent from '../components/events_list_component'

const mapStateToProps = (state) => {
  const formattedLeagues = state.leagues
  const leaguesOrder = state.misc.leaguesOrder || []
  const formattedLeaguesIds = leaguesOrder
  let statusesIndex = []

  if (formattedLeaguesIds.length > 0 && Object.keys(formattedLeagues).length > 0) {
    statusesIndex.push( { status: formattedLeagues[formattedLeaguesIds[0]].registered === true ? 'registered' : formattedLeagues[formattedLeaguesIds[0]].registrationInfo.status, id: formattedLeagues[formattedLeaguesIds[0]].id } )
  }

  if (statusesIndex[0] && statusesIndex[0].status === 'registered') {
    for (let i = 1; i < Object.keys(formattedLeagues).length; i++) {
      if (formattedLeagues[formattedLeaguesIds[i]].registrationInfo.status !== statusesIndex[statusesIndex.length - 1].status) {
        if (!formattedLeagues[formattedLeaguesIds[i]].registered) {
          statusesIndex.push( { status: formattedLeagues[formattedLeaguesIds[i]].registrationInfo.status || 'registration-disabled', id: formattedLeagues[formattedLeaguesIds[i]].id })
          break 
        }
      }
    }
  } else {
    statusesIndex = []
  }

  return {
    viewType: state.filters.viewType,
    leagues: formattedLeagues,
    customerTimeFormat: state.misc.customerTimeFormat,
    cartMerchantAccountId: state.misc.cartMerchantAccountId,
    cartMerchantAccountType: state.misc.cartMerchantAccountType,
    statusFilter: state.filters.status,
    idsForLabels: _.mapValues(_.keyBy(statusesIndex, 'id'), 'status'),
    dataIsLoading: !!state.misc.dataIsLoading,
    scrollPosition: state.filters.scroll,
    showCourseInfo: state.misc.showCourseInfo,
    directoryHideGolfers: state.misc.directoryHideGolfers,
    shouldSort: state.misc.shouldSort,
    shouldShowFilters: state.misc.shouldShowFilters,
    shouldHideRegistration: state.misc.shouldHideRegistration,
    sortedLeagueIds: leaguesOrder,
  }
}

const mapDispatchToProps = dispatch => ({
  addToCart: (url) => dispatch(addToCart(url)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsListComponent)
